export const ORDER_STATUS = {
  success: "已成功",
  failed: "已失败",
  confirming: "已支付，确认中",
  unpaid: "待支付",
  canceled: "已取消",
  refund: "已退款"
};
export const ORDER_DETAIL_STATUS = {
  success: "已成功",
  failed: "已失败",
  confirming: "确认中",
  unpaid: "待支付",
  canceled: "已取消",
  refund: "已退款",
  paid: "已支付"
};

export const ACTIVITY_ENUM = {
  end: {
    activityText: "本场已结束",
    btnName: "已结束",
    detailText: "已结束",
    statusName: "已结束",
    class: "end",
    text: "END",
    typeText: "下次再来",
    actionClass: "disable"
  },
  start: {
    activityText: "离本场结束",
    btnName: "立即抢",
    detailText: "距离结束",
    statusName: "抢购中",
    class: "start",
    text: "抢",
    typeText: "秒杀进行中",
    actionClass: ""
  },
  unstart: {
    activityText: "离本场开始",
    detailText: "距离开始",
    btnName: "开抢",
    statusName: "即将开始",
    class: "unstart",
    text: "预",
    typeText: "秒杀开始前",
    actionClass: ""
  }
};


export const MATTER_ORDER_STATUS = {
  "pending": "初始化",
  "unpaid": "待支付",
  "paid": "待发货",
  "confirming": "待收货",
  "success": "已成功",
  "failed": "已失败",
  "canceled": "已取消",
  "refund": "已退款",
};

export const REFUND_MATTER_STATUS = {
  "pending": "客服待接单",
  "reviewing": "客服审核中",
  "returning": "待寄回",
  "receiving": "待收货",
  "received": "已收货",
  "completed": "售后已完成",
  "cancelled": "售后已取消",
}
export const WXJK_ORDER_STATUS = {
  canceled: "已取消",
  pending: "待确认",
  confirmed: "已确认",
  paying: "支付中",
  paid: "已支付",
  refunding: "退款中",
  refund: "已退款",
};

// 预订单状态
export const PRE_ORDER_STATUS = {
  pending: "待确认",
  canceled: "已取消",
  confirmed: "已确认",
  paid: "已支付",
  refunding: "退款中",
  failed: "退款失败",
  refund: "已退款",
  expired: "已过期",
  refundpart: "部分退款",
}